import React from 'react';
import { Navbar } from 'react-bootstrap';
import { Container, Row, Col, Button } from 'react-bootstrap';

export default class NotFound extends React.Component {
    render() {
        const team = this.props.team;
        const detail = team
            ? <>We couldn't find a meet for <strong>{team}</strong>. Double-check the link.</>
            : <>The page you're looking for doesn't exist.</>;

        return (
            <>
                <Navbar className="padded-nav-bar" bg="primary" variant="dark" expand="lg" fixed="top">
                    <Navbar.Brand href="/">Meet Cruiser</Navbar.Brand>
                </Navbar>
                <Container className="text-center">
                    <Row style={{ minHeight: '25vh' }} />
                    <Row>
                        <Col>
                            <h1 style={{ fontSize: '5rem', fontWeight: 'bold' }}>404</h1>
                            <p style={{ fontSize: '1.25rem' }}>{detail}</p>
                            <Button variant="primary" href="/">Back to Meet Cruiser</Button>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}
